import req from "@/axios/index.js";

const baseURL = process.env.VUE_APP_BASE_API;

// ***********上传****************
// 修改医生视频状态
export function pubSigPutUrl(params) {
  return req("get", "upload/pubSigPutUrl", params, { baseURL });
}

// 华为云上传
export function putFile(url, data, fileType) {
    var result = '';
    var xhr = new XMLHttpRequest();
    xhr.open('PUT', url, true); /* PUT和getObjectUrl填写的Method对应 */
    xhr.setRequestHeader('Content-type', fileType);
  
    return new Promise(function(resolve, reject) {
      xhr.onload = function(e) {
        resolve({ code: 0, mag: e });
      };
      xhr.onerror = function(e) {
        result = { code: 1, mag: e };
        reject(result);
      };
      xhr.send(data);
    });
  }